
<div class="sign-status success">
  <div class="icon-wrapper">
    <mat-icon  color="primary">check_circle</mat-icon>
  </div>

  <h2>Document Signed Successfully</h2>

  <p>
    Thank you! Your signature has been recorded.
  </p>

  <!--<button mat-raised-button color="primary">
    Contact Sender
  </button>-->
</div>
